// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".thank-you[data-v-8c6340c8]{max-width:800px;margin:auto}.thank-you .order-confirmation[data-v-8c6340c8]{font-size:2em;text-align:center}.thank-you .order-confirmation .order-number[data-v-8c6340c8]{font-size:2.5em;color:#777}.thank-you a[data-v-8c6340c8]{color:#000}", ""]);
// Exports
module.exports = exports;
